import { AxiosResponse } from 'axios';
import { decamelize } from 'humps';
import checkrApiClient from 'api/checkrApiClient';
import TokenNotProvidedError from 'api/tokenNotProvidedError';
import {
  CHECKR_BFF_API_BASE,
  SESSION_STORAGE_TOKEN_KEY,
} from '../../constants';
import {
  FetchReportParams,
  PostDisputeIntakeParams,
  ReportReponse,
  UpdateCandidateBody,
  UpdateCandidateParams,
} from './types';

const decamelizeOneDepthKeys = (params: Record<string, any>) =>
  Object.fromEntries(
    Object.entries(params).map(([key, value]) => [decamelize(key), value]),
  );

const convertParamsToBody = ({
  candidateId: _candidateId,
  ...candidateOmittedId
}: UpdateCandidateParams): UpdateCandidateBody => {
  return decamelizeOneDepthKeys(
    candidateOmittedId,
  ) as unknown as UpdateCandidateBody;
};

export const patchCandidate = (
  params: UpdateCandidateParams,
): Promise<{ [key: string]: any }> => {
  const userAccessToken = window.sessionStorage.getItem(
    SESSION_STORAGE_TOKEN_KEY,
  );

  return checkrApiClient.patch(
    `${CHECKR_BFF_API_BASE}/candidates/${params.candidateId}`,
    {
      ...convertParamsToBody(params),
      token: userAccessToken,
    },
  );
};

export const postDisputeIntake = (
  params: PostDisputeIntakeParams,
  jwt?: string | null,
  portalToken?: string | null,
): Promise<
  AxiosResponse<{
    [key: string]: string;
  }>
> => {
  return checkrApiClient.post<{
    [key: string]: string;
  }>(
    `${CHECKR_BFF_API_BASE}/dispute_intake`,
    decamelizeOneDepthKeys({
      ...params,
      ...(!jwt && portalToken ? { token: portalToken } : {}),
    }),
    jwt ? { headers: { Authorization: `Bearer ${jwt}` } } : undefined,
  );
};

export const fetchReport = async ({
  id,
  token,
}: FetchReportParams): Promise<AxiosResponse<ReportReponse>> => {
  if (!token) throw new TokenNotProvidedError();

  const reportsPath = '/reports/';

  return checkrApiClient.get(`${CHECKR_BFF_API_BASE}${reportsPath}${id}`, {
    params: { token },
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
    },
  });
};
